module.exports = __webpack_public_path__ + "static/alerts-c1f50cf6a29810c25b30c9c1ebc0bb40.png";